import Kaleb from "../Kaleb";
import Header from "../header";
import ProjectColumn from "../projectColumn";
export default function Home() {
    return (<div className="App">
        <Header />
        <Kaleb />
        <ProjectColumn />
    </div>);
}